import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../auth/AuthContext';

export default function SignIn() {
  const { signIn, error } = useAuth();

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logoBox}>
          <div style={styles.logoMark}>CCCo</div>
          <div style={styles.brand}>Crafted Capital Co.</div>
          <div style={styles.subtitle}>Internal Portal</div>
        </div>

        <div style={styles.divider} />

        <div style={styles.signinBlock}>
          <div style={styles.instruction}>
            Sign in with your Crafted Capital Co. Google account to continue.
          </div>

          <div style={styles.buttonWrap}>
            <GoogleLogin
              onSuccess={signIn}
              onError={() => {
                // Errors are shown via context
              }}
              theme="filled_blue"
              size="large"
              shape="rectangular"
              text="signin_with"
              width="280"
            />
          </div>

          {error && (
            <div style={styles.error}>{error}</div>
          )}

          <div style={styles.notice}>
            Access is restricted to @craftedcapitalco.com accounts.
          </div>
        </div>
      </div>

      <div style={styles.footer}>
        © {new Date().getFullYear()} Crafted Capital Co. · Confidential
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(180deg, #F0F5FC 0%, #D0E0F5 100%)',
    padding: '24px',
  },
  card: {
    width: '100%',
    maxWidth: '420px',
    background: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(13, 53, 101, 0.15)',
    overflow: 'hidden',
    border: '1px solid #C5D5EA',
  },
  logoBox: {
    background: '#154D97',
    padding: '32px 24px',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  logoMark: {
    fontSize: '28px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    marginBottom: '8px',
  },
  brand: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '4px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#7EA3D7',
    fontWeight: '500',
    letterSpacing: '0.3px',
  },
  divider: {
    height: '2px',
    background: '#7EA3D7',
  },
  signinBlock: {
    padding: '36px 28px',
    textAlign: 'center',
  },
  instruction: {
    fontSize: '15px',
    color: '#0D2545',
    marginBottom: '24px',
    lineHeight: '1.5',
  },
  buttonWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
  },
  error: {
    background: '#FEE',
    color: '#B00020',
    border: '1px solid #FCC',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    marginTop: '8px',
    marginBottom: '8px',
    textAlign: 'left',
  },
  notice: {
    marginTop: '20px',
    fontSize: '13px',
    color: '#3A6BA8',
    fontStyle: 'italic',
  },
  footer: {
    marginTop: '24px',
    fontSize: '12px',
    color: '#3A6BA8',
  },
};
